import {
  ThemeProvider as MUIThemeProvider,
  StyledEngineProvider,
  createTheme,
  ThemeOptions,
} from "@mui/material";
import { ReactNode, useMemo } from "react";

import * as MUILocales from "@mui/material/locale";
import * as MUIDataGridLocales from "@mui/x-data-grid-premium/locales";
import { useLocalization } from "@Hooks";
import { Components, Palette, Typography } from "@Theme";

const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const { currentLanguage } = useLocalization();

  const locale =
    currentLanguage === "tr"
      ? "trTR"
      : currentLanguage === "en"
        ? "enUS"
        : "trTR";

  const ThemeOptions: ThemeOptions = useMemo(
    () =>
      createTheme(
        {
          palette: Palette,
          typography: Typography,
        },
        MUIDataGridLocales[locale],
        MUILocales[locale]
      ),

    [locale]
  );

  const Theme = createTheme(ThemeOptions);

  Theme.components = Components(Theme, locale) as never;

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={Theme}>
        {/* <CssBaseline /> */}
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeProvider;
